import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import HelyszinContent from './HelyszinContent';
import TeremContent from './TeremContent';
import TeremKiosztasContent from './TeremKiosztasContent';
import SzektorContent from './SzektorContent';
import KulsokliensContent from './KulsokliensContent';
import PubszinContent from './PubszinContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './HelyszinTooltips';

class HelyszinBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: undefined,
      isHelyszinTabActive: false,
      isTeremTabActive: false,
      isTeremKiosztasTabActive: false,
      isSzektorTabActive: false,
      isKulsoKliensTabActive: false,
      isPubszinTabActive: false,
    };
  }
  
  componentDidMount() {
    if (this.props.globals.hasRole(['HELYSZIN_HELYSZIN'])) {
      this.toggle('1');
    } else if (this.props.globals.hasRole(['HELYSZIN_TEREM'])) {
      this.toggle('2');
    } else if (this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS'])) {
      this.toggle('3');
    } else if (this.props.globals.hasRole(['JEGYTERMEK_SZEKTOR'])) {
      this.toggle('4');
    } else if (this.props.globals.hasRole(['HELYSZIN_KULSOKLIENS'])) {
      this.toggle('5');
    } else if (this.props.globals.hasRoleSpec(['HELYSZIN_PUBSZIN'])) {
    // } else if (true) {
      this.toggle('6');
    }
  }
  
  toggle(tab) {
    this.setState({
      isHelyszinTabActive: tab === '1',
      isTeremTabActive: tab === '2',
      isTeremKiosztasTabActive: tab === '3',
      isSzektorTabActive: tab === '4',
      isKulsoKliensTabActive: tab === '5',
      isPubszinTabActive: tab === '6'
    });
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {'Helyszín'}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['HELYSZIN_HELYSZIN']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => {
                          this.toggle('1');
                          // if (this.child1) this.child1.updateTable();
                        }}
                      >
                        {'Helyszínek'}
                        <CustomTooltip text={getTooltip('helyszinek')} id="helyszinekTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['HELYSZIN_TEREM']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => {
                          this.toggle('2');
                          // if (this.child2) this.child2.updateTable();
                        }}
                      >
                        {'Termek'}
                        <CustomTooltip text={getTooltip('termek')} id="termekTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => {
                          this.toggle('3');
                          // if (this.child2) this.child2.updateTable();
                        }}
                      >
                        {'Teremkiosztások'}
                        <CustomTooltip text={getTooltip('teremkiosztasok')} id="teremkiosztasokTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['JEGYTERMEK_SZEKTOR']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '4' })}
                        onClick={() => {
                          this.toggle('4');
                          // if (this.child2) this.child2.updateTable();
                        }}
                      >
                        {'Szektorok'}
                        <CustomTooltip text={getTooltip('szektorok')} id="szektorokTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['HELYSZIN_KULSOKLIENS']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '5' })}
                        onClick={() => {
                          this.toggle('5');
                          // if (this.child3) this.child3.updateTable();
                        }}
                      >
                        {'Külső kliens'}
                        <CustomTooltip text={getTooltip('kulsokliens')} id="kulsokliensTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRoleSpec(['HELYSZIN_PUBSZIN']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '6' })}
                        onClick={() => {
                          this.toggle('6');
                          // if (this.child3) this.child3.updateTable();
                        }}
                      >
                        {'Publikus dizájn'}
                        <CustomTooltip text={getTooltip('pubszin')} id="pubszinTT" />
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.props.globals.hasRole(['HELYSZIN_HELYSZIN']) && (
                    <TabPane tabId="1">
                      <HelyszinContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isHelyszinTabActive}
                        ref={(instance) => { this.child1 = instance; }}
                      />
                    </TabPane>
                  )}
                  {this.props.globals.hasRole(['HELYSZIN_TEREM']) && (
                    <TabPane tabId="2">
                      <TeremContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isTeremTabActive}
                        ref={(instance) => { this.child2 = instance; }}
                      />
                    </TabPane>
                  )}
                  {this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS']) && (
                    <TabPane tabId="3">
                      <TeremKiosztasContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isTeremKiosztasTabActive}
                        ref={(instance) => { this.child3 = instance; }}
                      />
                    </TabPane>
                  )}
                  {this.props.globals.hasRole(['JEGYTERMEK_SZEKTOR']) && (
                    <TabPane tabId="4">
                      <SzektorContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isSzektorTabActive}
                        ref={(instance) => { this.child4 = instance; }}
                      />
                    </TabPane>
                  )}
                  {this.props.globals.hasRole(['HELYSZIN_KULSOKLIENS']) && (
                    <TabPane tabId="5">
                      <KulsokliensContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isKulsoKliensTabActive}
                        ref={(instance) => { this.child5 = instance; }}
                      />
                    </TabPane>
                  )}
                  {this.props.globals.hasRoleSpec(['HELYSZIN_PUBSZIN']) && (
                    <TabPane tabId="6">
                      <PubszinContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isPubszinTabActive}
                        ref={(instance) => { this.child6 = instance; }}
                      />
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HelyszinBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default HelyszinBase;
